<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <i class="fa-regular fa-life-ring icon"></i>
        <span>Dúvidas frequentes</span>
      </h1>
    </div>
  </div>


  <div class="align p-4 space_title">
    <div class="card">
      <div class="p-4" id="table_filter">
        <InputText placeholder="Buscar" v-model="filter.search" />
      </div>
      <div class="table_container">
      <table>
        <thead>
          <tr>
            <th>Título</th>
            <th>Data</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(faq, key) in faqs.data" :key="key">
            <td>
              {{ faq.title }}
            </td>
            <td>
              {{ $dateFormat(faq.created_at) }}
            </td>
            <td class="actions">
              <div class="dropdown">
                <router-link :to="{ name: 'faq', params: { id: faq.id }}">
                  <button class="btn btn-secondary" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fa-regular fa-edit"></i>
                  </button>
                </router-link>
              </div>
            </td>
          </tr>
          <tr class="no_result" v-if="!faqs.data || (faqs.data && !faqs.data.length)">
            <td colspan="10">
              Nenhum resultado encontrado
            </td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>


    <ListPagination class="mt-4" :links="faqs.meta.links" />
  </div>
</template>
  
<script setup>
import { onBeforeMount, watch } from 'vue';
import { useFaqStore } from '@/stores/FaqStore'
import { storeToRefs } from 'pinia';
import ListPagination from '@/components/ListPagination.vue'
import { inject } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import InputText from '@/components/InputText.vue'

const loader = inject('$loader');

const router = useRouter();
const route = useRoute();
const faqStore = useFaqStore();
const { filter, faqs } = storeToRefs(faqStore);


onBeforeMount(() => {
  if (route.query.search) {
    filter.value.search = route.query.search;
  }

  loadFaqs();
});

watch(() => route.query.page, (newPage, oldPage) => {
  if (newPage !== oldPage) {
    window.scrollTo(0, 0);
    loadFaqs();
  }
});

watch(() => filter.value.search, debounce(() => {
  const new_query = { ...route.query, page: 1, search: filter.value.search };
  router.push({ query: new_query }).then(() => {
    loadFaqs();
  });
}, 500));

function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
 
async function loadFaqs() {
  loader.show();
  filter.value.page = parseInt(route.query.page);
  filter.value.limit = 10;

  await faqStore.getFaqs();
  loader.hide();
}
</script>